export default "__VITE_ASSET__DV78VE3x__"